import { getCurrentUser } from "modules/current_user/actions";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Card, CardBody, CardHeader } from "reactstrap";
import { getCurrentUserPageResponsibilities } from "../actions";
import TableTorch from "modules/5_view_helpers/web/TableTorch";
import { Link } from "react-router-dom";

function mapStateToProps(state) {
  return {
    current_user: state.current_user,
    current_user_page_responsibilities: state.current_user_page_responsibilities,
  };
}

const CurrentUserWorkflows = (props) => {
  const { current_user, current_user_page_responsibilities } = props;

  useEffect(() => {
    props.getCurrentUserPageResponsibilities();
  }, []);

  const columns = [
    {
      header: "Workflow Created Date",
      dataKey: "record_created_at",
      sort: true,
      cellRenderer: (cell) => fd(cell),
    },
    {
      header: "Name",
      dataKey: "record_display_name",
      sort: true,
    },
    {
      header: "Open",
      dataKey: "open",
      cellRenderer: (cell, row) => <Link to={`/custom_form/${row.custom_form_id}/records/${row.record_id}/edit?tab=${row.page_guid}`}>Open</Link>,
    },
  ];

  return (
    <Card>
      <CardHeader>
        <h3>{current_user?.name} - Assigned Workflow Pages</h3>
      </CardHeader>
      <CardBody>
        <h3>Incomplete Workflow Pages</h3>

        <TableTorch columns={columns} data={current_user_page_responsibilities} />
      </CardBody>
    </Card>
  );
};

export default connect(mapStateToProps, { getCurrentUser, getCurrentUserPageResponsibilities })(CurrentUserWorkflows);
